
import { useAxios } from '../../../../../../../../hooks/useAxios';
import { TarifasAdapters } from '../adapters/tarifas.adapter';

const TarifasServices = {

    GET: function (id: string) {

        return useAxios({ method: 'get', url: `/slam/productos-tarifas/${id}/show`, type: 'json', adapters: TarifasAdapters.GET })
    },

    GET_ID: function () {

        return useAxios({ method: 'get', url: `/slam/productos-tarifas`, type: 'json', adapters: TarifasAdapters.GET })
    },

    POST: function () {

        return useAxios({ method: 'post', url: `/slam/productos-tarifas/create`, type: 'json', adapters: TarifasAdapters.POST })
    },

    PATCH: function (id: string) {

        return useAxios({ method: 'patch', url: `/slam/productos-tarifas/${id}/update`, type: 'json', adapters: TarifasAdapters.PATCH })
    },

    DELETE: function (id: string) {

        return useAxios({ method: 'delete', url: `/slam/productos-tarifas/${id}/delete`, type: 'json', adapters: TarifasAdapters.DELETE })
    }
}

export {
    TarifasServices
}